<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>

export default {
  mounted() {
    let url = window.location.href
    let path = url.split('#/')[1]
    console.log(this._isMobile(), this.$route, navigator.userAgent)
    if (this._isMobile()) {
      if (path.slice(0, 1) == 'm') {
        this.$router.replace(url.split('#/')[1])
      } else {
        console.log(`/m${url.split('#/')[1] ? url.split('#/')[1] : 'home'}`)
        console.log('/m' + url.split('#/')[1])
        console.log(Boolean('/m' + url.split('#/')[1]))
        this.$router.replace(`/m${url.split('#/')[1] ? url.split('#/')[1] : 'home'}`)
      }
    } else {
      if (path.slice(0, 1) == 'm') {
        this.$router.replace('/' + path.slice(1, path.length))
      } else {
        this.$router.replace('/' + path)
      }
    }
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      return flag
    },
  },
}
</script>
<style lang="scss"></style>
